export default {
  defaultLocale: 'zh-tw',
  allowLocales: [{
    code: 'zh-tw',
  }, {
    code: 'en-us',
  }, {
    code: 'zh-cn',
  }, {
    code: 'zh-hk',
  }, {
    code: 'vi',
  }],
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/configs/locale.js
 **/